var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopTabSaveListingHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.465 15.6067C9.21 15.6967 8.79 15.6967 8.535 15.6067C6.36 14.8642 1.5 11.7667 1.5 6.51672C1.5 4.19922 3.3675 2.32422 5.67 2.32422C7.035 2.32422 8.2425 2.98422 9 4.00422C9.7575 2.98422 10.9725 2.32422 12.33 2.32422C14.6325 2.32422 16.5 4.19922 16.5 6.51672C16.5 11.7667 11.64 14.8642 9.465 15.6067Z",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopTabSaveListingHeart);
export default __webpack_public_path__ + "static/media/TopTab-SaveListing-Heart.641a97fac1faa3c0cff2bf888cd26bca.svg";
export { ForwardRef as ReactComponent };